import { useCallback, useEffect, useMemo, useState } from "react";
import { BILLING_CREDIT_OUTLET_STORAGE_KEY, getVisibleAppBranches } from "../../config/appBranches";

/**
 * Branch filter state aligned with Pending Orders / Order Reports (`allowedBranches`).
 * Stays in sync with Billing credit outlet via {@link BILLING_CREDIT_OUTLET_STORAGE_KEY}.
 * @param {{ role?: string, allowedBranches?: unknown } | null | undefined} storedUser — e.g. `useAuth().user`
 */
export function useCreditBranchFilter(storedUser) {
  const visibleBranches = useMemo(() => getVisibleAppBranches(storedUser || null), [storedUser]);
  const [branch, setBranchState] = useState(() => visibleBranches[0]?.value || "Main");

  useEffect(() => {
    const allowed = new Set(visibleBranches.map((b) => b.value));
    try {
      const sync = localStorage.getItem(BILLING_CREDIT_OUTLET_STORAGE_KEY);
      if (sync && allowed.has(sync)) {
        setBranchState(sync);
        return;
      }
    } catch {
      /* ignore */
    }
    setBranchState((prev) => (allowed.has(prev) ? prev : visibleBranches[0]?.value || "Main"));
  }, [visibleBranches]);

  const setBranch = useCallback((v) => {
    setBranchState(v);
    try {
      localStorage.setItem(BILLING_CREDIT_OUTLET_STORAGE_KEY, v);
    } catch {
      /* ignore */
    }
  }, []);

  return { branch, setBranch, visibleBranches };
}
